import React from "react";
import { Link } from "react-router-dom";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <section className="hero-section">
        <div className="hero-image">
          <img src="/main/a1.webp" alt="Our Story" />
        </div>
        <div className="hero-content">
          <h1 className="hero-title">Our Story</h1>
          <p className="hero-text">
            mefurvexo explores jewellery through clean lines, natural motifs,
            and small details that feel personal in everyday life.
          </p>
        </div>
      </section>

      <section className="journey-section">
        <div className="journey-header">
          <h2 className="journey-title">Jewels of the Journey</h2>
          <p className="journey-text">
            Our collection moves between quiet geometry, organic curves, and
            subtle celestial references. The goal is simple: expressive pieces
            that remain easy to combine and comfortable to wear.
          </p>
        </div>
        <div className="journey-images">
          <img src="/main/a2-2.webp" alt="Jewellery" />
          <img src="/main/a2-3.webp" alt="Jewellery" />
        </div>
      </section>

      <section className="sketch-section">
        <div className="sketch-content">
          <h2 className="sketch-title">From Sketch to Treasure</h2>
          <p className="sketch-text">
            Every mefurvexo concept begins with proportion and silhouette. We
            refine how a piece catches light, how its closure works, and how it
            appears from the front and side before it joins the collection.
          </p>
          <p className="sketch-text">
            Material and finish information is listed on each product page.
            Clear descriptions help customers understand the piece they are
            choosing and the care it needs over time.
          </p>
        </div>
      </section>

      <section className="beauty-section">
        <div className="beauty-image">
          <img src="/main/a3.webp" alt="Beauty with Purpose" />
        </div>
        <div className="beauty-content">
          <h2 className="beauty-title">Beauty with Purpose</h2>
          <p className="beauty-text">
            We favour lasting forms and clear material information, encouraging
            thoughtful choices and careful use over time.
          </p>
        </div>
      </section>

      <section className="circle-section">
        <div className="circle-header">
          <h2 className="circle-title">A Circle of Hands & Hearts</h2>
          <p className="circle-text">
            At mefurvexo, creativity grows through observation, feedback, and
            careful refinement. Product concepts are considered as a complete
            experience, from the first sketch to the information shown online.
          </p>
          <p className="circle-text">
            We value original design, useful details, and respectful customer
            care. Those principles guide the collection and the way we present
            every piece.
          </p>
        </div>
        <div className="circle-images">
          <img src="/main/a4-1.webp" alt="Jewellery 1" />
          <img src="/main/a4-2.webp" alt="Jewellery 2" />
        </div>
      </section>

      <section className="final-section">
        <div className="final-text">
          <p>
            Our jewellery is born from love, shaped by hand, and designed to
            travel with you through every moment worth remembering.
          </p>
        </div>
        <div className="final-image">
          <img src="/main/a5.webp" alt="Final" />
          <div className="store-info">
            <h3 className="store-title">Our Online Studio</h3>
            <p className="store-address">
              Visit the shop online or contact our customer-care team.
            </p>
            <div className="store-hours">
              <p>Customer care: Monday–Friday</p>
              <p>Email enquiries are welcome anytime</p>
            </div>
            <p className="store-note">
              We respond as soon as possible during customer-care days.
            </p>
            <Link to="/shop" className="directions-btn">Visit shop</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
